/**
 * 高级查询相关逻辑
 */
import templateUtil from '../../../static/js/templateUtil'
//根据配置设置默认值
export function setDefaultVal(criteriaFormDefData) {
  const numberTypeArray = ['FLOAT', 'DOUBLE', 'DECIMAL', 'MONEY', 'LONG', 'INTEGER']
  const temp = {}
  const items = criteriaFormDefData.items // 侧滑高级差询条件
  const groups = criteriaFormDefData.groups // 分组查询条件
  if (items) {
    for (let i = 0; i < items.length; i++) {
      let item = items[i]
      if (item.property && item.defaultValue) {
        // defaultValue 缺省值
        let defaultValue = templateUtil.compileData(item.defaultValue, {})
        if (numberTypeArray.indexOf(item.type.code) > -1) defaultValue = Number(defaultValue) //数据类型是number的话转换为number
        temp[item.property] = defaultValue
      }
    }
  }
  if (groups) {
    for (let i = 0; i < groups.length; i++) {
      let group = groups[i]
      if (group.property && group.chosen) {
        temp[group.property] = true
      }
    }
  }
  return temp
}
